// extracted by mini-css-extract-plugin
module.exports = {"Bio":"Bio_Bio__3aLWi"};